import config from './config.js';

const { STORAGE_PREFIX } = config;
export class Storage {
  /** @type {localStorage} */
  storage;
  constructor() {}

  /**
   * Saves the value into local storage under the key.
   * @template T
   * @param {string} key
   * @param {T} value
   * @returns {void}
   */
  setItem(key, value) {
    key = STORAGE_PREFIX + key;
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Retrieves the value from local storage with the key.
   * @param {string} key
   * @returns {StorageItems[keyof StorageItems] | null}
   */
  getItem(key) {
    key = STORAGE_PREFIX + key;
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  /**
   * Returns user sound and theme preferences.
   * @returns {{
   *   isSound: StorageItems['isSound'],
   *   isDarkTheme: StorageItems['isDarkTheme']
   * }}
   */
  getPreferences() {
    let isSound = /** @type {StorageItems['isSound'] | null} */ (
      this.getItem('isSound')
    );
    if (isSound === null) {
      isSound = true;
      this.setItem('isSound', true);
    }
    let isDarkTheme = /** @type {StorageItems['isDarkTheme'] | null} */ (
      this.getItem('isDarkTheme')
    );
    if (!isDarkTheme) {
      isDarkTheme = false;
      this.setItem('isDarkTheme', false);
    }
    return { isSound, isDarkTheme };
  }

  /**
   * Saves user result in local storage.
   * @param {Result} result
   * @returns {void}
   */
  storeResult(result) {
    let results = /** @type {StorageItems['results'] | null} */ (
      this.getItem('results')
    );
    if (results === null) {
      results = [];
      this.setItem('results', results);
    }

    results.push(result);

    if (results.length > 5) results.shift();
    this.setItem('results', results);
  }
}

export default new Storage();
